import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/app/[locale]/providers.tsx");
